module.exports = __webpack_public_path__ + "img/20.f809f787.png";